export default [
    {
        path: '/tendero/productos',
        meta: { nombre: 'Productos' },
        name: 'tendero.productos',
        component: () => import('../../pages/productos/tendero').then(m => m.default || m)
    }
]
